var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFlowerSpa = function SvgFlowerSpa(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M6.404 8.9A8.6 8.6 0 0 1 9.5 12.134q.253-.47.564-.9A8.6 8.6 0 0 1 12.596 8.9a8.7 8.7 0 0 1 4.519-1.256h.292c.327 0 .593.261.593.583C18 12.521 14.461 16 10.093 16H8.907C4.539 16 1 12.52 1 8.226c0-.322.266-.583.593-.583h.292c1.65 0 3.2.458 4.519 1.256m3.494-5.738c.464.49 1.804 2.084 2.491 4.777A9.6 9.6 0 0 0 9.5 10.423a9.6 9.6 0 0 0-2.89-2.484c.685-2.693 2.025-4.286 2.492-4.776A.55.55 0 0 1 9.5 3c.15 0 .295.055.398.163"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFlowerSpa);
export default ForwardRef;